import { render, staticRenderFns } from "./DescargarReportes.vue?vue&type=template&id=2f79bf99&scoped=true&"
import script from "./DescargarReportes.vue?vue&type=script&lang=js&"
export * from "./DescargarReportes.vue?vue&type=script&lang=js&"
import style0 from "./DescargarReportes.vue?vue&type=style&index=0&id=2f79bf99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f79bf99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VIcon,VProgressLinear})
